import { ChartView } from '@principle-theorem/principle-core/interfaces';
import { ISerialisedDocumentReference } from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';

export interface IStafferDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  user: IBigQueryNamedDocument;
  teams: IBigQueryNamedDocument[];
  tasks: {
    watching: number;
    assigned: number;
  };
  quickChartingConfiguration: {
    conditions: IBigQueryReffable[];
    treatments: IBigQueryReffable[];
    multiTreatments: IBigQueryReffable[];
  };
  providerCommission?: number;
  settings?: Partial<IStafferSettings>;
  providerDetails: IProviderData[];
}

interface IProviderData {
  practiceRef: ISerialisedDocumentReference;
  providerNumber: string;
  /**
   * ServiceTypeModality is an invalid avro enum
   */
  providerModality: string;
}

interface IStafferSettings {
  charting: {
    view?: ChartView;
  };
}
